import { render, staticRenderFns } from "./MissingMessage.vue?vue&type=template&id=242e2ad2&"
import script from "./MissingMessage.vue?vue&type=script&lang=js&"
export * from "./MissingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports